/*=========================================================================================
  File Name: moduleCompanyMutations.js
  Description: Company Module Mutations
 ==========================================================================================*/

export default {
  UPDATE_USER_VENUE(state, payload) {
      state.id  = payload.id
      state.name  = payload.name
      state.place_id  = payload.place_id
      state.display_name  = payload.display_name
      state.street  = payload.street
      state.house_number  = payload.house_number
      state.suffix  = payload.suffix
      state.postal_code = payload.postal_code
      state.city  = payload.city
      state.country = payload.country
      state.timezone  = payload.timezone
      state.telephone = payload.telephone
      state.longitude = payload.longitude
      state.latitude  = payload.latitude
      state.max_bookings  = payload.max_bookings
      state.extra_info_driver = payload.extra_info_driver
      state.company_comment = payload.company_comment
      state.internal_comment  = payload.internal_comment
  }

}

